module.exports = "/assets/b01aa9a08544b61f1d5cac6361d4f5d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IG.png
// module id = 2598
// module chunks = 0